<template>
    <li>
        <a :href="targetRoute" @click.prevent="handleNotificationClick">{{ unreadNotification.title }}</a>
    </li>
</template>

<script>
    export default {
        props: ['unreadNotification', 'readRouteBase'],
        computed: {
            // Se c'è un link specifico, usa quello, altrimenti usa la route standard
            targetRoute() {
                return this.unreadNotification.link || this.unreadNotification.view_route;
            },
            // Verifica se la notifica ha un link personalizzato o usa la route standard
            hasCustomLink() {
                return !!this.unreadNotification.link;
            }
        },
        methods: {
            handleNotificationClick() {
                // Se la notifica ha un link personalizzato, naviga normalmente
                if (this.hasCustomLink) {
                    this.markAsReadAndNavigate();
                    return;
                }
                
                // Se usa la route standard, apri la modale
                this.openNotificationModal();
            },
            openNotificationModal() {
                // Chiama la funzione globale per aprire la modale
                if (typeof window.openNotificationModal === 'function') {
                    // Segna come letta prima di aprire la modale
                    const readRoute = this.readRouteBase + '/' + this.unreadNotification.id + '/read';
                    
                    axios.post(readRoute)
                        .then((res) => {
                            // Emetti evento per aggiornare il contatore e rimuovere la notifica dalla lista
                            Event.$emit('notificationRead', res.data.unreadNotificationsCount, res.data.notificationId, res.data.infoMessage);
                            
                            // Apri la modale
                            window.openNotificationModal(this.unreadNotification.id);
                        })
                        .catch((error) => {
                            console.error('Errore nel segnare la notifica come letta:', error);
                            // Apri comunque la modale
                            window.openNotificationModal(this.unreadNotification.id);
                        });
                } else {
                    // Fallback: se la funzione non è disponibile, naviga normalmente
                    console.warn('openNotificationModal non disponibile, navigazione normale');
                    this.markAsReadAndNavigate();
                }
            },
            markAsReadAndNavigate() {
                const readRoute = this.readRouteBase + '/' + this.unreadNotification.id + '/read';
                
                axios.post(readRoute)
                    .then((res) => {
                        // Emetti evento per aggiornare il contatore e rimuovere la notifica dalla lista
                        Event.$emit('notificationRead', res.data.unreadNotificationsCount, res.data.notificationId, res.data.infoMessage);
                        
                        // Naviga alla destinazione (link specifico o view_route)
                        window.location.href = this.targetRoute;
                    })
                    .catch((error) => {
                        console.error('Errore nel segnare la notifica come letta:', error);
                        // Naviga comunque alla pagina
                        window.location.href = this.targetRoute;
                    });
            }
        }
    }
</script>